import { WIZ_EVENT_TYPE, VALUE_ESCAPE, WizMathUtils, WizDateUtils, WIZ_PHYSIC_POSITION, WIZ_UPLOAD_ACCEPT_FORMAT, VALUE_ENTER, CODE_SPACE, CONFIRMATION_MODE, CONFIRMATION_RESULT } from '@wizeoo/akm-core-lib';
import {
  WizBasePopUp,
  WizLabel,
  WizEventManager, WizEvent,
  WizTextInput,
  WizTextarea,
  WizDropdown,
  WizDateField,
  WizPopUp,
  WizIcon,
  WizVgroup,
  WizValidationContainerDirective,
  WizDatasource,
  WizGroupCommand,
  WizRoot,
  WizList,
  WizGroup,
  UploadParameter,
  WizHgroup,
  WizImage,
  ImageUploadParameter,
  ConfirmationResultObj
} from '@wizeoo/akm-component-lib';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, HostListener, ViewChild } from '@angular/core';
import { FeiVO } from '../../../../../vo/workingdata/fei.vo';
import { IWidget } from '../../../../../manager/widgets/i-widget';
import { PivotCellEditPopData } from '../../../../../manager/widgets/i-widget';
import { EM_ACTION, FeiKeyDef, WidgetLine, WizConstants, WorkcomParameters, WorkComReply, WorkComVO } from '@wizeoo/akm-compute-lib';
import { Attachment, DataPack } from '@wizeoo/akm-message-lib';

import { UpdateRequest } from '../../../../../command/core/sync/sync.service';
import { ViewData } from '../../../../../model/view.data';
import { Model } from '../../../../../model/model';
import { FakeVO } from '../../../../../vo/common/tool/fake.vo';
import { FindWorkComCommand } from '../../../../../command/workflow/find-workcom.cmd';
import { UserServiceCmd } from '../../../../../command/user/user.cmd';
import { FreedataValueVO } from '../../../../../vo/core/freedatavalue.vo';
import { WorkcomMessageRenderer } from './workcom-message.renderer';
import { WorkcomMessagePop } from './workcom-message.pop';
import { PopUtils } from '../../../../../framework/components/pop/pop-utils';
import { ALK_EVENT_TYPE } from '../../../../../model/enums';
import { AlkEvent } from '../../../../../framework/events/alk.event';
import { WorkflowEngine } from '../../../../../manager/workflow/workflow.engine';
import { Observable, of } from 'rxjs';
import { AttachmentService, MediaReference } from '../../../../../command/core/attachment/attachment.service';
import { zoomPopParams } from '../../../../../components/widgets/freedatas/renderers/zoom.pop';

// exemple de conf
// {"item":"last","fields":["state@icon","object","state","targetDate"],"render":"thumb","mode":"chat","lock":true}



@Component({
  // popUp d'édition des cellules de type workflow
  selector: 'pivot-cell-workflow-edit-pop',
  templateUrl: './pivot-cell-workflow-edit.pop.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PivotCellWorkflowEditPop extends WizBasePopUp {
  // @ViewChild('lbTitle', { read: WizLabel, static: false }) lbTitle: WizLabel; // titre de la popUp (fullcode)

  @ViewChild('tiObj', { read: WizTextInput }) tiObj: WizTextInput; 
  @ViewChild('taContent', { read: WizTextarea }) taContent: WizTextarea; 
  //@ViewChild('taRecipient', { read: WizTextInput }) taRecipient: WizTextInput; 
  @ViewChild('taParams', { read: WizTextarea }) taParams: WizTextarea;
  @ViewChild('ddState', { read: WizDropdown }) ddState: WizDropdown;
  @ViewChild('daStart', { read: WizDateField }) public daStart: WizDateField;
  @ViewChild('daEnd', { read: WizDateField }) public daEnd: WizDateField;
 
  @ViewChild('icoAdd', { read: WizIcon }) public icoAdd: WizIcon;
  @ViewChild('vgEdition', { read: WizVgroup }) vgEdition: WizVgroup; // ensemble de la zone de détail pour écoute ModelUpdate
  @ViewChild('vgEdition', { read: WizValidationContainerDirective, static: false })
  private vgEditionCheck: WizValidationContainerDirective; // Zone de validation globale

  @ViewChild('lst', { read: WizList }) public lst: WizList;
 
  public message: boolean = true;
  public recipient: boolean = false;
  public file: boolean = false;
  public media: boolean = false;


  // validation sur enter, sortie sur Esc
  @HostListener('window:keydown', ['$event'])
  keyEvent(event: KeyboardEvent) {
    if (event.key === VALUE_ESCAPE) {
      this.doCancel();
    }
  }

  /** accesseur avec cast */
  private get popupData(): PivotCellEditPopData {
    return this.datas as PivotCellEditPopData;
  }

  public hasChanged: boolean = false;

  public currentWorkcom: WorkComVO = null; // sélection active (objet métier vrai)
  public clone: WorkComVO = null; // clone de travail
  public naturalUID: string = null;

  public createBy: string = null;
  public createTime: string = null;




  // public columns: ColDef[]; // Colonnes du grid
  

  /** la DS ee la liste. On recycle le mécanisme d'alimentation des filtres, il marche bien avec freedata et chrono */
  // public mainDS: WizDatasource<FreedataValueVO> = new WizDatasource<FreedataValueVO>([])
  //   .setFilter(this.fdvFilterFunc.bind(this))
  //   .setSelectionMode('single')
  //   .setSortFields([{ property: 'trsLabel', way: 'asc', numeric: false }])
  //   .build();

 
  public static baseWidth: number = 340;
  public static baseHeight: number = 520;

  public fei: FeiVO = null; // l'instance de FEI manipulée par ce composant
  public widget: IWidget; // accesseur sur le widget
  public line: WidgetLine; // la pl de référence pour update
  public fdv: FreedataValueVO;
  public pack: WidgetLine[]; // le pool de line effectif. Prise en compte de l'aggrégat en colonne
  private fkd: FeiKeyDef;


  constructor(public elementRef: ElementRef, protected cdref: ChangeDetectorRef) {
    super();
  }

  renderer: any = WorkcomMessageRenderer;

  public params: WorkcomParameters = null;

  public get exist(): boolean {
    return this.clone?.exist;
  }

  /** datasource des messages */
  public messageDS: WizDatasource<WorkComReply> = new WizDatasource<WorkComReply>()
  .setItemCodeField('idx')
  .setSortFields([{ property: 'idx', way: 'desc', numeric: true }])
  .setSelectionMode('none')
  .build();


  public get model(): Model {
    return this.widget?.model;
  }

  /** DS de la drop de types de données */
  public stateDS: WizDatasource<FakeVO> = new WizDatasource<FakeVO>(ViewData.getInstance().workflowState)
    .setSortFields([{ property: 'order', way: 'asc', numeric: true }])
    .build();

  /** chargements en attente */
  private needLoading: boolean = false;

  private listenersInPlace: boolean = false;

  public onShow(): void {
    const commands = [];
    // chargement des messages
    if (!Model.getInstance().workcomList) {
      commands.push(new FindWorkComCommand(Model.getInstance()));
    }
    // chargement des users
    if(!Model.getInstance().usersMap) {
      // Chargement des users
      commands.push(new UserServiceCmd(Model.getInstance()).find());

    }

    if (commands.length > 0) {
      this.needLoading = true;
      new WizGroupCommand().configure(commands, this.reallyLoaded.bind(this), false).execute();
    }
    super.onShow();
  }

  /**
   * chargement initial
   * @param e 
   */
  private reallyLoaded(e: any): void {
    this.needLoading = false;
    this.feedWorkCom();
    // console.log('reallyLoaded');
    this.addListeners();
    // if(this.currentWorkcom && !this.currentWorkcom.loaded) {
    //   this.currentWorkcom = this.model.workflowEngine.getWorkCom(this.popupData.value);
    //   //console.log('reallyLoaded', this.currentWorkcom);
    //   this.feedWorkCom();
    // }
  }

  show(): void {
    this.widget = this.popupData.widget;
    this.fei = this.widget.fei as FeiVO;
    this.line = this.popupData.line;
    this.pack = this.popupData.pack;
    this.fkd = this.popupData.fkd;
    this.fdv = this.popupData.fdv;

    // console.log('work show', this.line, this.fkd, this.pack);


    if(this.popupData.value) {
      this.naturalUID = this.popupData.value;
    } else {
      if(!!this.line) { // message sur BL
        this.naturalUID = [this.line.key, this.fkd.fullCode].join(WizConstants.FD_PARTS_SEPARATOR);
      }else if(!!this.fdv) {// message sur FDV
        this.naturalUID = [this.fdv.freeDataCode, this.fdv.code, this.popupData.arg?.code].join(WizConstants.FD_PARTS_SEPARATOR);
      } else {// message sans attache
        this.naturalUID = WizMathUtils.createUUID();
      }
    }
    

    this.feedDatasources();

    if(!this.needLoading) {
      this.feedWorkCom();
      // console.log('not needLoading');
      this.addListeners();
    }

  }

  public feedWorkCom(): void {
    
      // this.currentWorkcom = this.model.workflowEngine.getWorkCom(this.popupData.value);
      //console.log('this.currentWorkcom', this.currentWorkcom);
    if(this.popupData.value) {
      this.currentWorkcom = this.model.workflowEngine.getWorkCom(this.naturalUID);
    } 

    if(!this.currentWorkcom) { // pas trouvé ou pas de données
      this.currentWorkcom = Model.getInstance().workflowEngine.buildFake();
      this.currentWorkcom.naturalUID = this.naturalUID;
      this.currentWorkcom.obj = this.datas.title;
     
    }
    
    this.clone = Model.getInstance().workflowEngine.clone(this.currentWorkcom);
    this.params = this.clone.params || null;
    
    this.tiObj.wizValue = this.clone.obj; // alimentation du code  
    
      
    let firstMess: WorkComReply = null;
    if(this.clone.exist) {
      firstMess = WorkflowEngine.replyFromWC(this.clone);
      firstMess.idx = 0;
    }
    
    let source: WorkComReply[] = [];
    if(firstMess) {
      source.push(firstMess);
    }
    if(this.params?.replies) {
      source = [...source, ...this.params.replies];
    } 

    this.messageDS.setSource(source);




      // if(params.to) {
      //   let toArr: string[] = params.to;
      //   this.taRecipient.wizValue = toArr.join(WizConstants.STYLE_ELEMENT_SEPARATOR);
      // }

    if(this.params?.imgBlob) {
      this.imgBlob = this.params?.imgBlob;
      this.imgSrcObs = AttachmentService.getInstance().downloadAttachmentForWidget(this.imgBlob, true);
      this.img.sourceObservable = this.imgSrcObs;
    } else {
      this.imgBlob = null;
      this.imgSrcObs = of(null);
    }

      if(this.params?.media) {
        this.mediaReference = this.params?.media; // JSON.parse(params.media);  
        // this.mediaBlob = (params.media as Attachment).blobId;
        // this.mediaReference = AttachmentService.getInstance().downloadAttachmentForWidget(this.mediaBlob);
        // this.img.sourceObservable = this.imgSrcObs;
      } else {
        //this.mediaBlob = null;
        this.mediaReference = null;
      }




      // if(params.to) {
      //   let toArr: string[] = params.to;
      //   let selectedUsers: UserVO[] = [];
      //   let us: UserVO;
      //   toArr.forEach(s => {
      //     us = this.usersDS.getItemByKey(s);
      //     if(!!us) {
      //       selectedUsers.push(us);
      //     }
      //   });

      //   this.usersDS.select(selectedUsers);

      //}

      // if (this.clone.exist) {
      //   this.tiObj.wizDisabled = true;
      // } else {
      //   this.tiObj.wizDisabled = false;
      //   // setTimeout(() => {
      //   //   // sinon, pas le temps de rendre les compos enabled
      //   //   this.tiObj.wizFocus();
      //   //   this.cdref.markForCheck();
      //   // }, 0);
      // }

  }

  /** sur séquence de démarrage, alimentation des listes avec leurs DS */
  public feedDatasources(): void {
    // console.log('cellParams', this.params);
    // this.lbTitle.wizLabel = this.datas.title;
    this.ddState.wizDataProvider = this.stateDS; // alimentation de la drop des types de données

  }

  /** mise en place des écouteurs */
  public addListeners(): void {
    if(!this.listenersInPlace) {
      WizEventManager.addListener(this, this.vgEdition, WIZ_EVENT_TYPE.MODEL_UPDATE, this.updateModel); // écouteur global change pour modelUpdate
      WizEventManager.addListener(this, WizRoot.root(), ALK_EVENT_TYPE.DELETE_WORKCOM_MESSAGE, this.removeMessage);
      WizEventManager.addListener(this, WizRoot.root(), ALK_EVENT_TYPE.EDIT_WORKCOM_MESSAGE, this.editMessage);
      this.listenersInPlace = true;
    }
  }

  // édition de mon message
  private editMessage(e: AlkEvent): void {
    // console.log('editMessage main Pop', e);
    this.doAddReply(e.data);
  }

  private removeMessage(e:AlkEvent): void {
    let wcr: WorkComReply = e.data;
    //this.params.replies.splice(this.params.replies.indexOf(wcr));
    this.messageDS.removeItem(wcr);
    this.messageDS.refresh();
    this.hasChanged = true;
    // console.log('removeMessage', wcr);
  }

  /** Sauvegarde, même valeur */
  public save(w: WorkComVO): void {
    let value: string
    if(w) {
      value = w.naturalUID;
    } else {
      value = null;
    }


    const updates: UpdateRequest = {
      fei: this.fei, 
      line: this.line,
      lines: this.pack, 
      operation: EM_ACTION.UPDATE,
      fkd: this.fkd,
      value,
      doSplit: false
    };

    this.popupData.updates = updates;
    this.popupData.callback(this.popupData); // on appelle la callback avec le pack d'updates

    this.hide();
  }

  /** annulation des modifs */
  public doCancel(): void {
    // this.doSaveFlag = false;
    this.hide();
  }

  /**
   * popUp d'ajout de message
   * édition de l'existant si présent
   */
  public doAddReply(origin: {wcr: WorkComReply, callback: Function} = null): void {

  let pop = new WizPopUp(
      WorkcomMessagePop,
      false,
      false,
      null,
      WorkcomMessagePop.baseWidth + 'px',
      WorkcomMessagePop.baseHeight + 'px',
      [this.model, this.clone, origin],
    );

    pop.callback = this.backFromMessage.bind(this);

    const pos: DOMRect = this.icoAdd.elementRef.nativeElement.getBoundingClientRect();

    const bestXY: [number, number] = PopUtils.setPopCoord(pos, pop, WIZ_PHYSIC_POSITION.BOTTOM_RIGHT);
    const x: string = bestXY[0] + 'px';
    const y: string = bestXY[1] + 'px';
    const targetPosition: any = { left: x, top: y }; // position physique
    pop.customPosition = targetPosition;

    pop.show();
  }

  /** ajout d'une réponse */
  public backFromMessage(newWcr: WorkComReply, callback?: Function): void {

    if(newWcr.idx >= 0) { // modif d'un message existant (0 = main)
      
      let exist: WorkComReply;
      this.messageDS.getSource().forEach(wcr => {
        if(wcr.idx === newWcr.idx) {
          exist = wcr;
          exist.content = newWcr.content;
          exist.date = newWcr.date;
          exist.state = newWcr.state;
          exist.startDate = newWcr.startDate;
          exist.endDate = newWcr.endDate;
        }
      });
      // console.log('backFromMessage exist', exist);
      // this.messageDS.removeItem(exist);
      // this.messageDS.addItem(newWcr);
      this.messageDS.refresh();
 
    } else {
      let idx: number = 1;
      this.messageDS.getSource().forEach(wcr => {
        if(wcr.idx > idx) {
          idx = wcr.idx;
        }
      });
      idx++;
      newWcr.idx = idx;
      this.messageDS.addItem(newWcr);
    }
    
    
    //console.log("backFromMessage", newWcr);
    this.hasChanged = true;

    if(callback) {
      callback(newWcr);
    }

    // this.cdref.markForCheck();
  }

  public onHide() {
    WizEventManager.removeListener(this, this.vgEdition, WIZ_EVENT_TYPE.MODEL_UPDATE);
    WizEventManager.removeListener(this, WizRoot.root(), ALK_EVENT_TYPE.DELETE_WORKCOM_MESSAGE);
    WizEventManager.removeListener(this, WizRoot.root(), ALK_EVENT_TYPE.EDIT_WORKCOM_MESSAGE);
    // console.log("onHide");
    // super.hide();
  }

  /**
   * modification d'un élément de modèle
   * @param e WizEvent
   */
  private updateModel(e: WizEvent): void {
    switch(e.component) {   
      case this.icoAddFile: 
        if(e.value) {
          let med: Attachment = e.value[0];
          let blobId: string = e.value[1];
          this.mediaReference = {fileName: med.fileName, fileType: med.fileType, blobId: blobId, shortFileName: med.fileName.substring(0,50), v2: false, directory: null};
        }
      break;
      case this.icoDelFile: 
          this.mediaReference = null;
      break;
      case this.img:
        if(e.value) {
          this.imgBlob = e.value;
          this.imgSrcObs = AttachmentService.getInstance().downloadAttachmentForWidget(this.imgBlob, true);
        } else {
          this.imgBlob = null;
          this.imgSrcObs = of(null);
        }
        // this.img.sourceObservable = AttachmentService.getInstance().downloadAttachmentForWidget(valueStr, false);
      break;
    }
       
    this.hasChanged = true;
  }

  /** desactivation des boutons save et cancel sur updateModel */
  public disableButtons(): boolean {
    return !this.hasChanged;
  }

  /** persistence sur save */
  public doMerge(): void {

    this.clone.obj = this.tiObj.wizValue;

    if(!this.clone.exist) { // création
      this.clone.comment = this.taContent.wizValue;
    
      let params: WorkcomParameters = {};
      params.from = this.model.connectedUser.mail;
      params.state = this.ddState.selectedItem?.code || null;   
      params.startDate = this.daStart.wizNumberValue || null;
      params.endDate = this.daEnd.wizNumberValue || null;
      params.replies = null;
      if(this.imgBlob) {
        params.imgBlob = this.imgBlob;
      } 
      if(this.mediaReference) {
        params.media = this.mediaReference;
      }

      this.clone.params = params;
    } else {
      let firstMessage: WorkComReply;
      let replies: WorkComReply[] = [];
      this.messageDS.getSource().forEach(wcr => {
        if(wcr.idx === 0) {
          firstMessage = wcr;
          this.clone.comment = firstMessage.content;
          this.clone.params.state = firstMessage.state;   
          this.clone.params.startDate = firstMessage.startDate;
          this.clone.params.endDate = firstMessage.endDate;
        } else {
          replies.push(wcr);
        }
      });
      this.clone.params.replies = replies;

      if(this.imgBlob) {
        this.clone.params.imgBlob = this.imgBlob;
      } else {
        delete this.clone.params.imgBlob;
      }
      if(this.mediaReference) {
        this.clone.params.media = this.mediaReference;
      } else {
        delete this.clone.params.media;
      }

    }
    

    const errors = this.vgEditionCheck.check(true, true);
    if (!errors || (!!errors && errors.length === 0)) {
      Model.getInstance().workflowEngine.merge(this.clone, this.currentWorkcom, this.backFromMerge.bind(this));
    } else {
      WizPopUp.toast('$.common.toast.pending.error.$', WizIcon.TOAST_ERROR).show();
    }
  }

  /**
   * Callback sur retour de persistence
   * @param bddBack style créé ou modifié ou supprimé
   * @param operation CUD
   */
  private backFromMerge(pack: DataPack): void {
    // console.log("yo", pack);
    let vo: WorkComVO = new WorkComVO(this.model, pack.inWorkComs[0]);
    // passer par le save pour la valeur
    this.save(vo);
  }

  /** déclenche une action */
  public do(action: string): void {
    this.message = false;
    this.recipient = false;
    this.file = false;
    this.media = false;
    this[action] = true;
    this.cdref.markForCheck();

  }


  /* ##############################################################################
          pièces jointes
  ############################################################################## */

  @ViewChild('dropGrp', { read: WizGroup, static: false }) dropGrp: WizGroup; // zone de drop de fichier
  @ViewChild('icoAddFile', { read: WizIcon, static: false }) icoAddFile: WizIcon; // ajout de fichier
  @ViewChild('icoDelFile', { read: WizIcon, static: false }) icoDelFile: WizIcon; // suppression du lien de fichier


  public imgSrcObs: Observable<string> = of(null);
  public mediaReference: MediaReference = null;

  public imgBlob: string = null;

  /** on utilise le lien vers un fichier, et il existe */
  public get dropFull():boolean {
    // console.log('dropFull', this.datakind, this. formatedValue);
    return !!this.mediaReference;
  }
  
 /**
   * neutralisation du dragOver, sinon le drop ne fonctionne pas...sous chrone
   */
  public dover(evt: DragEvent): void {
    evt.preventDefault();
    evt.stopImmediatePropagation();
    // console.log('dover', evt);
  }

  /**
     * Demande de chargement d'un fichier
     */
  public selectFile(): void {

    let params: UploadParameter = {
      callback: null, // sera alimenté par le batchEngine
      accept: [WIZ_UPLOAD_ACCEPT_FORMAT.FILE_ANY],
      multiple: false, // false par défaut
      maxSize: 30, // 30 Mo
      elementRef: this.dropGrp.elementRef,
      targetPath: null,
      viewCallback: this.backFromSelect.bind(this)
    }
    this.model.batchEngine.loadFile(params);
  }

  /**
   * retour de sélection de fichier
   * @param params 
   */
  private backFromSelect(params: UploadParameter): void {
    if(params.files?.length > 0) {
      params.viewCallback = this.backFromDrop.bind(this);
      this.model.batchEngine.dropFile(params);
    }
  } 

  /**
   * Demande de chargement par drop
   */
  public dropFile(evt: DragEvent): void {
    
    evt.preventDefault();
    evt.stopImmediatePropagation();
    const files = evt.dataTransfer.files;
    let file: File = files[0];
  
    let params: UploadParameter = {
      callback: null, // sera alimenté par le batchEngine
      accept: [WIZ_UPLOAD_ACCEPT_FORMAT.FILE_ANY],
      multiple: false, // false par défaut
      maxSize: 30, // 30 Mo
      elementRef: this.dropGrp.elementRef,
      targetPath: null,
      files: [file],
      viewCallback: this.backFromDrop.bind(this)
    }
    
    this.model.batchEngine.dropFile(params);
  }

  /**
   * retour de chargement, enregistrement
   * @param media 
   * @param blobId 
   */
  private backFromDrop(media: Attachment, blobId: string): void {  
    WizEventManager.dispatchEvent(this.icoAddFile.elementRef, new WizEvent(WIZ_EVENT_TYPE.MODEL_UPDATE, this.icoAddFile, [media, blobId]));
    this.cdref.markForCheck();
  }

  /**
   * suppression de la pièce jointe
   */
  public clearDropFile(): void {
    WizEventManager.dispatchEvent(this.icoDelFile.elementRef, new WizEvent(WIZ_EVENT_TYPE.MODEL_UPDATE, this.icoDelFile, null));
    this.cdref.markForCheck();
  }

  /**
   * chargement de la pièce jointe
   */
  public loadDropFile(): void {
    AttachmentService.getInstance().filedownloadForWidget(this.mediaReference);
  }


//   /* ##############################################################################
//           image
//   ############################################################################## */

  @ViewChild('imgGp', { read: WizHgroup, static: false }) imgGp: WizHgroup; // image du FDV
  @ViewChild('img', { read: WizImage, static: false }) img: WizImage;
  
  /** présence d'une image, pour affichage de la poubelle */
  public get hasImage(): boolean {
    return !!this.imgSrcObs;
  }

 /**
   * Demande de chargement d'une image
   * sur clic long, ouverture du zoom
   * @param target FD pour l'icone du FD, FDV pour l'icone d'un FDV
   */
  public clickForUpload(latency: number): void {

    // console.log('clickForUpload', latency, this.rawValue); 
    let params: ImageUploadParameter = {
          component: this.img,
          elementRef: this.img.elementRef,
          dom: this.model.domainCode,
          bu: this.model.businessUnitCode,
          vision: ViewData.wildcardMainVision,
        }
    this.model.batchEngine.loadImage(params);
    
  }

  /**
   * demande d'ouverture sur l'image picker par clavier; touche entrée ou espace
   * @param event event clavier
   * @param target FD pour l'icone du FD, FDV pour l'icone d'un FDV
   */
  public keydownForUpload(event: KeyboardEvent): void {
    const isEnterKey = event.key === VALUE_ENTER; // touche entrée
    const isSpaceKey = event.code === CODE_SPACE; // touche espace
    if (isEnterKey || isSpaceKey) {
      this.clickForUpload(0);
    }
  }

  /**  de suppression des... icones */
  public clearImage(): void {
    this.img.sourceObservable = of(null);
    WizEventManager.dispatchEvent(this.img.elementRef, new WizEvent(WIZ_EVENT_TYPE.MODEL_UPDATE, this.img, null));
  }

  private zoomPop: WizPopUp; // la popUp de zoom sur les images
  /**
   * zoom sur une image
   */
  public seeImage(e: Event= null): void {
      let params: zoomPopParams = {
        zoomPop: this.zoomPop,
        blobid: this.imgBlob,
        // arg: this.data.arg,
        //fdvDS: this.data.ds
      }   
    PopUtils.showZoomPop(params);
  }
  
  public get hasFileClass(): string {
    let myclass: string = 'image-purple';
    if(!!this.mediaReference) {
      myclass = 'image-orange';
    }
    return myclass;
  }

  public get hasMediaClass(): string {
    let myclass: string = 'image-purple';
    if(!!this.imgBlob) {
      myclass = 'image-orange';
    }
    return myclass;
  }

  public askForDelete(): void {
    console.log('doDelete', this.clone);
    WizPopUp.confirm(
          '$.common.delete.title.$',
          '$.common.delete.detail.$',
          this.doDelete.bind(this),
          CONFIRMATION_MODE.CONFIRM_CANCEL,
          null,
          null,
          null
        ).show();
  }


  private doDelete(confirmationResult: ConfirmationResultObj): void {
    if (confirmationResult.result === CONFIRMATION_RESULT.CONFIRM) {
      Model.getInstance().workflowEngine.remove(this.clone, this.backFromDelete.bind(this));
    }
  }

  /**
   * Callback sur retour de persistence
   * @param bddBack style créé ou modifié ou supprimé
   * @param operation CUD
   */
  private backFromDelete(pack: DataPack): void {
    // console.log("backFromDelete", pack);
    this.save(null);
  }

}
